<script>
import { VMenu } from 'vuetify/lib';
export default VMenu;
</script>
